







































































import { Component, Vue } from 'vue-property-decorator';
import { curPref, Preferences } from '@/services/Preferences';
import { AlertsPage, BaseStation, BssPage, FullAlert } from '@/types';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import PageNav from '@/components/PageNav.vue';
import AlertRow from '@/components/alerts/AlertRow.vue';
import AlertRowMobile from '@/components/alerts/AlertRowMobile.vue';
import { ApiService, curApiService } from '@/services/ApiService';
import { ApiClient, curApiClient } from '@/services/ApiClient';

@Component({
  components: {
    Error,
    Loading,
    AlertRow,
    AlertRowMobile,
    SearchBox,
    PageNav,
  },
})
export default class Alerts extends Vue {
  
  httpBusy:boolean = false;
  httpClearBusy:boolean = false;
  error:string = '';
  pageList:AlertsPage[] = [];
  curPage:AlertsPage = {} as AlertsPage;
  searchTerm = curPref.retrieve('alerts-search-term', '');
  
  // services
  apiService:ApiService = curApiService;
  apiClient:ApiClient = curApiClient;
  
  mounted() {
    this.refreshData();
  }

  async refreshData() {

    this.httpBusy = true;
    const reply = await this.apiService.getActiveAlerts({searchTerm: this.searchTerm});
    this.httpBusy = false;
    
    if(reply.errorMsg)
      return this.error = `Unable to load active alerts ${reply.errorMsg}`;

    this.pageList = reply.pageList!;

    // we set the current page
    if(this.pageList.length > 0) {

      // we call the reset on the component
      (this.$refs.pageNav as PageNav).reset();

      this.curPage = this.pageList[0];
    }
  }

  newSearchText(newSearchText:string) {
    curPref.store('alerts-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  get showPageNav():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  get showRows():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  changePage(newPageNum:number) {
    this.curPage = this.pageList[newPageNum];
  }

  async clearAlert(alertId:string) {
    
    this.httpClearBusy = true;
    const reply = await this.apiClient.clearAlert({alertId:alertId});
    this.httpClearBusy = false;
    
    if(reply.errorMsg)
      return this.error = `Unable to clear alert ${alertId}: ${reply.errorMsg}`;

    this.refreshData();
  }
}
